<template>
  <div>
    <p>Welcome to VAM!</p>
  </div>
</template>

<script>
export default {
  name: "Welcome",
}
</script>

<style></style>
